import moment from 'moment'

/**
 * 日期转字符串
 * @param value 日期
 * @param format  格式, 默认 YYYY-MM-DD
 */
const date2str = (value: string, format?: string): string => {
  return format ? moment(value).format(format) : moment(value).format('YYYY-MM-DD')
}

/**
 * 日期转字符串
 * @param value
 * @param format
 */
const datetime2str = (value: string): string => {
  return moment(value).format('YYYY-MM-DD HH:mm:ss')
}

const monthFirstDay = (): moment.Moment => {
  return moment().startOf('month')
}

const monthLastDay = (): moment.Moment => {
  return moment().endOf('month')
}

/**
 * 一周前
 */
function aWeekAgo(): moment.Moment {
  return moment().subtract(7, 'day');
}

/**
 * 此时此刻
 */
function now(): moment.Moment {
  return moment();
}

let Date = {
  date2str,
  datetime2str,
  monthFirstDay,
  monthLastDay,
  aWeekAgo,
  now,
}

export default Date
